import React from 'react';
import styled from 'styled-components';
import { Product } from '../../model/Products';
import { ApiRequest } from '../../utils/api';
import { useApiQuery } from '../../utils/apiHooks';
import { OfferingType } from '../../utils/offeringType';

interface Props {
	showErrors: boolean;
	onProductPackageChange: (value: any) => void;
	selectedSubscription: any;
	offeringType: OfferingType;
}

const SelectionContainer = styled.div`
	margin-top: 5em;
	h4 {
		text-align: center;
		margin: auto;
		margin-bottom: 1em;
	}
`;

const ProductRow = styled.div`
	max-width: 30em;
	margin: auto;
	.text-container {
		width: 64%;
		float: left;
	}
	.package-name {
		font-size: 1rem;
		padding-top: 1em;
		display: inline-block;
	}
	.package-price {
		font-size: 1rem;
		display: inline-block;
		float: right;
		padding-top: 1em;
	}
	button {
		padding: 0.6em 0.5em 0.6em 0.5em;
		margin-top: 0.5em;
		border-radius: 10px;
		min-width: 10em;
		background-color: red;
		color: white;
		font-weight: 600;
		border: 2px solid red;
		float: right;
	}

	button:hover,
	button:focus {
		background-color: #d90000;
	}

	button.selected:hover,
	button.selected:focus {
		background-color: #fafafa;
	}

	.grayed-out {
		background-color: white;
		border: 2px solid #969696;
		color: #969696;
	}

	.selected {
		background-color: #fafafa;
		border: 2px solid #eaeaea;
		color: black;
		float: right;
		font-weight: 300;
	}

	.info {
		margin: 1.2em 0 1.2em 0;
		padding-bottom: 0.2em;
		display: inline-block;
		width: 100%;
		font-size: 0.7em;
		color: #969696;
	}
	border-bottom: 1px solid #eaeaea;
`;

const ErrorMessage = styled.div`
	color: red;
`;

const getProductDescription = (product: Product, offeringType: OfferingType) => {
	const { dataSpeedMbs, addToSharedDataGbAmount, eurPerMoi, maxEurMoisPerMonth, euDataLimitMB } = product;

	const hasUnlimitedVoice = product.orderItemCode.endsWith('ULV');
	const hasUnlimitedData = product.dataPackage === 'unlimited';

	return `${dataSpeedMbs} Mbit/s,
			${!hasUnlimitedData ? `${addToSharedDataGbAmount}Gt` : 'Rajaton määrä'} dataa, 
			${offeringType === OfferingType.CONSUMER4 ? ` EU-roaming ${parseInt(euDataLimitMB) / 1000} Gt. ` : ''}
			${!hasUnlimitedVoice ? `Puhelut ${eurPerMoi}€/min` : 'Rajattomasti kotimaan puhetta'} ja tekstiviestit ${eurPerMoi}€/kpl 
			${offeringType !== OfferingType.CONSUMER2B ? `, mutta aina enintään ${maxEurMoisPerMonth}€/kk` : ''}`;
};

const renderPackage = (product: Product, selectedSubscription: any, onProductPackageChange: (value: any) => void, key: number, offeringType: OfferingType) => {
	const { displayName, orderItemCode, eurPerMonth } = product;
	const renderSelected = selectedSubscription !== null && selectedSubscription.packageSpecs.value && orderItemCode === selectedSubscription.packageSpecs.value.orderItemCode;
	return (
		<ProductRow onClick={() => onProductPackageChange(product)} key={key} className={key === 0 ? 'first-child' : ''}>
			{renderSelected && (
				<div className={'title-row'}>
					<div className={'text-container'}>
						<span className={'package-name'}>{displayName}</span>
						<span className={'package-price'}>{eurPerMonth}€/KK</span>
					</div>
					<button className={'selected'}>Valitsemasi uusi liittymä</button>
				</div>
			)}
			{!renderSelected && (
				<div className={'title-row'}>
					<div className={'text-container'}>
						<span className={'package-name'}>{displayName}</span>
						<span className={'package-price'}>{eurPerMonth}€/KK</span>
					</div>
					<button>Valitse</button>
				</div>
			)}
			<div className={'info'}>
				<span className={'info-text'}>{getProductDescription(product, offeringType)}</span>
			</div>
		</ProductRow>
	);
};

// TODO: Combine this component and ProductPackageTypeSeletion component in simsettings
export const SelectProductPackage: React.FC<Props> = (props: Props) => {
	const { data: products } = useApiQuery(ApiRequest.getProducts(props.offeringType), { cacheTime: 600000 });

	return (
		<SelectionContainer>
			<h4>Valitse liittymä</h4>
			{props.showErrors && !props.selectedSubscription.packageSpecs.valid && <ErrorMessage>Valitse liittymätyyppi</ErrorMessage>}
			{products !== undefined && products.productPackagePrices.map((value, key) => renderPackage(value, props.selectedSubscription, props.onProductPackageChange, key, props.offeringType))}
		</SelectionContainer>
	);
};
